import React from "react";
import Select, { components } from "react-select";
import DexSelectDivStyled from "./DexSelectDivStyled";

const options = [
  { value: 0, label: "List All", icon: "images/all.png" },
  { value: 1, label: "Pangolin", icon: "images/pangolin.png" },
  { value: 2, label: "TraderJoe", icon: "images/joe.png" },
  { value: 3, label: "Lydia", icon: "images/lyd_logo.png" },
];

// @ts-ignore
const ControlIconDex = ({ children, hasValue, getValue, ...rest }) => {
  return (
    // @ts-ignore
    <components.Control {...rest}>
      {hasValue && (
        <img
          key={getValue()[0].value}
          className="control-icon"
          src={getValue()[0].icon}
          alt={getValue()[0].label}
        />
      )}
      {children}
    </components.Control>
  );
};

const FarmDexSelect= ({ onChange }) => {
  const { Option } = components;

  // @ts-ignore
  const IconOptionDex = (props) => (
    <Option key={props.data.label} className="select-option" {...props}>
      <img
        key={props.data.label}
        className="option-icon"
        src={props.data.icon}
        alt={props.data.label}
      />

      {props.data.label}
    </Option>
  );

  return (
    <DexSelectDivStyled>
      <Select
        defaultValue={options[0]}
        options={options}
        clearable={true}
        components={{ Option: IconOptionDex, Control: ControlIconDex }}
        onChange={onChange}
        classNamePrefix="react-select"
      />  
    </DexSelectDivStyled>
  );
};

export default FarmDexSelect;
